import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { Credit } from 'types/api/loan'

/* ----------------------------- LOAN DETAIL STORE ----------------------------- */
/* 
use for storing the selected loan/advance card and rendering the info in loan detail page
*/

type LoanInfoState = {
  loanInfo: Credit
}

type LoanInfoAction = {
  updateLoanInfo: (loanInfo: Credit) => void
}

export const useLoanInfoStore = create<LoanInfoState & LoanInfoAction>()(
  persist(
    (set) => ({
      loanInfo: null,
      updateLoanInfo: (loanInfo: Credit) => set(() => ({ loanInfo }))
    }),
    {
      name: 'selected-loan-info',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)

/* ----------------------------- LINE SUMMARY STORE ----------------------------- */
/* 
use for storing the neccesary info for rendering banners and credit profile line detail information
*/

type LineSummary = {
  interestFreeIsDepleted?: boolean
  advanceLineIsDepleted?: boolean
  loanLineIsDepleted?: boolean
  loanApprovedAmount?: number
  advanceApprovedAmount?: number
  loanAllocatedAmount?: number
  advanceAllocatedAmount?: number
  loanRemainingAmount?: number
  advanceRemainingAmount?: number
}

type LineSummaryState = {
  lineSummary: LineSummary
}

type LineSummaryAction = {
  updateLineSummary: (lineSummary: LineSummary) => void
}

export const useLineSummaryStore = create<
  LineSummaryState & LineSummaryAction
>()(
  persist(
    (set) => ({
      lineSummary: null,
      updateLineSummary: (lineSummary: LineSummary) =>
        set(() => ({ lineSummary }))
    }),
    {
      name: 'line-summary-info',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)

/* ----------------------------- ACTIVE CREDITS STORE ----------------------------- */
/* 
use for credit profile's line summary information
*/

type ActiveCreditsState = {
  activeLoans: Credit[]
  activeAdvances: Credit[]
}

type ActiveCreditsAction = {
  updateActiveLoans: (loanInfo: Credit[]) => void
  updateActiveAdvances: (loanInfo: Credit[]) => void
}

export const useActiveCreditsStore = create<
  ActiveCreditsState & ActiveCreditsAction
>()(
  persist(
    (set) => ({
      activeLoans: [],
      activeAdvances: [],
      updateActiveLoans: (credit: Credit[]) =>
        set(() => ({ activeLoans: credit })),
      updateActiveAdvances: (credit: Credit[]) =>
        set(() => ({ activeAdvances: credit }))
    }),
    {
      name: 'active-credits',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
)
